



















import { ComponentInternalInstance, computed, defineComponent, getCurrentInstance } from '@vue/composition-api';
import { DeleteIcon } from 'tdesign-icons-vue';
import searchHandler from '@/renderer/scripts/composition/searchHandler';
import ipc from '@/renderer/scripts/utils/ipc';
export default defineComponent({
  components: {
    DeleteIcon,
  },
  props: {
    historyPopup: {
      type: Boolean,
      default: false,
    },
    historyStore: {
      type: Array,
      default: [],
    },
    historyMethods: {
      type: Object,
      default: {},
    },
    keyword: {
      type: String,
      default: '',
    },
    isSearchResult: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const innerPopupShow = computed({
      get() {
        return props.historyPopup;
      },
      set(val: any) {
        context.emit('update:historyPopup', val);
      },
    });
    const searchKeyword = computed<string>({
      get() {
        return props.keyword as string;
      },
      set(val) {
        context.emit('update:keyword', val);
      },
    });
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const isInFolder = computed(() => (vm.$route.query?.path ? vm.$route.query.path : ''));
    const { methods: searchMethods } = searchHandler();
    const methods = {
      /**
       * 选择搜索历史
       */
      onSelectHistory(e: Event) {
        const el = e.target as HTMLElement;
        if (['li', 'p'].includes(el.nodeName.toLowerCase()) && el.innerText) {
          innerPopupShow.value = false;
          searchKeyword.value = el.innerText;
          if (props.isSearchResult) {
            ipc.emit(ipc.RENDERER_EVENTS_MAP.COMMAND_SEARCH);
          } else {
            // 如果是工作台默认是全局搜索
            const spaceScope = isInFolder.value ? 'current' : 'all';
            const scope = vm.$route.name === 'workbench' ? 'global' : spaceScope;
            searchMethods.openSearch({
              keyword: el.innerText,
              scope,
            });
          }
        }
      },
      onClearHistory() {
        props.historyMethods.clearHistory();
      },
      onDeleteHistory(index: number) {
        props.historyMethods.deleteHistory(index);
      },
    };
    return {
      ...methods,
    };
  },
});
